import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import {
  CoachingSetupCardKind,
  parseCoachingSetupCard,
} from '@euler/model/coaching';
import { memo } from 'react';
import { DifficultyCard } from './DifficultyCard';
import { DrillOfferCard } from './DrillOfferCard';
import { StoryCard } from './StoryCard';
import { SummaryCard } from './SummaryCard';

/** A `coaching_setup_card` fence in a 知车 AI reply. */
export const CoachingSetupCardView = memo(({ data }: { data: unknown }) => {
  const card = parseCoachingSetupCard(data);
  if (!card) return <CardNotice text="这张练习卡片暂时显示不了。" />;
  switch (card.kind) {
    case CoachingSetupCardKind.Story:
      return <StoryCard story={card.story} />;
    case CoachingSetupCardKind.DrillOffer:
      return <DrillOfferCard title={card.title} />;
    case CoachingSetupCardKind.Difficulty:
      return <DifficultyCard subject={card.subject} levels={card.levels} />;
    case CoachingSetupCardKind.Summary:
      return <SummaryCard card={card} />;
  }
});
